import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { RecuperacaoCreditoRoutingModule } from './recuperacao-credito-routing.module';
import { RecuperacaoCreditoPesquisaComponent } from './recuperacao-credito-pesquisa.component';
import { RecuperacaoCreditoListagemComponent } from './recuperacao-credito-listagem.component';
import { RecuperacaoCreditoDetalheComponent } from './recuperacao-credito-detalhe.component';
import { RecuperacaoCreditoLoteEnvioComponent } from '../protocolo/recuperacao-credito-lote-envio.component';
import { RecuperacaoCreditoLotePesquisaComponent } from '../protocolo/recuperacao-credito-lote-pesquisa.component';
import { RecuperacaoCreditoCadastroComponent } from '../protocolo/recuperacao-credito-cadastro.component';
import { CalculoValorHonradoRecuperarComponent } from './calculo-valor-honrado-recuperar/calculo-valor-honrado-recuperar.component';
import { RecuperacoesInconsistentesComponent } from './recuperacoes-inconsistentes.component';

@NgModule({
  imports: [
    SharedModule,
    RecuperacaoCreditoRoutingModule
  ],
  declarations: [
    RecuperacaoCreditoPesquisaComponent,
    RecuperacaoCreditoListagemComponent,
    RecuperacaoCreditoDetalheComponent,
    RecuperacaoCreditoLoteEnvioComponent,
    RecuperacaoCreditoLotePesquisaComponent,
    RecuperacaoCreditoCadastroComponent,
    CalculoValorHonradoRecuperarComponent,
    RecuperacoesInconsistentesComponent
  ],
  providers: [
    DatePipe
  ]
})
export class RecuperacaoCreditoModule { }
